module.exports = __webpack_public_path__ + "static/media/but_class_begin.de093f36.svg";